import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { Document, FullClient } from '../../../domain/data';
import { DocumentTypeId } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-full-data-form-documents',
    templateUrl: './full-data-form-documents.component.html',
    styleUrls: ['./full-data-form-documents.component.scss'],
})
export class FullDataFormDocumentsComponent extends BaseUI implements AfterViewInit, OnDestroy {
    @Input()
    client: FullClient;

    @Input()
    isDisabled = false;

    @Input()
    notDisabledGuardianShip = false;

    @Output()
    view: EventEmitter<Document> = new EventEmitter();

    get documents() {
        if (this.client.uploadMultipleEnabled) {
            return this.client.documents.filter(
                (doc) =>
                    doc.typeId.value !== DocumentTypeId.DNI &&
                    doc.typeId.value !== DocumentTypeId.NIE &&
                    doc.typeId.value !== DocumentTypeId.NIE_NOT_RESIDENT
            );
        }

        return this.client.documents.filter(
            (doc) =>
                doc.typeId.value !== DocumentTypeId.DNI_FRONT_SIDE &&
                doc.typeId.value !== DocumentTypeId.DNI_BACK_SIDE &&
                doc.typeId.value !== DocumentTypeId.NIE_FRONT_SIDE &&
                doc.typeId.value !== DocumentTypeId.NIE_BACK_SIDE &&
                doc.typeId.value !== DocumentTypeId.NIE_NOT_RESIDENT_FRONT_SIDE &&
                doc.typeId.value !== DocumentTypeId.NIE_NOT_RESIDENT_BACK_SIDE
        );
    }

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    isDocumentDisabled(document: Document): boolean {
        if (this.notDisabledGuardianShip) {
            return !document.isGuardianShip || (document.isGuardianShip && document.isValidated());
        }

        return this.isDisabled;
    }

    onDocumentView(document: Document) {
        if (document.id) {
            this.view.next(document);
        }
    }

    onDocumentRemove(document: Document) {
        if (document.id) {
            document.remove = true;
        }
    }
}
